import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { HiMail, HiUser, HiChatAlt2, HiPaperAirplane } from "react-icons/hi";

const Contact = () => {
  const form = useRef();
  const [loading, setLoading] = useState(false);

  const sendEmail = (e) => {
    e.preventDefault();
    setLoading(true);

    emailjs
      .sendForm(
        "service_salxbyo",
        "template_tym8q4n",
        form.current,
        "ryyLtWJGkxgem99L0"
      )
      .then(
        () => {
          setLoading(false);
          form.current.reset();
          toast.success("Message sent successfully! ✅", {
            position: "top-right",
            autoClose: 3000,
            theme: "dark",
          });
        },
        (error) => {
          setLoading(false);
          console.error("Error sending message:", error);
          toast.error("Failed to send message. Please try again.", {
            position: "top-right",
            autoClose: 3000,
            theme: "dark",
          });
        }
      );
  };

  return (
    <section
      id="contact"
      className="py-28 px-[6vw] md:px-[8vw] lg:px-[15vw] relative bg-[#050414]"
    >
      <ToastContainer />

      {/* Section Title */}
      <div className="text-center max-w-3xl mx-auto mb-20 space-y-4">
        <h2 className="text-xs uppercase tracking-[0.3em] font-bold text-[#8245ec]">Get In Touch</h2>
        <h3 className="text-3xl sm:text-5xl font-extrabold text-white tracking-tight">Let's Build Something Together</h3>
        <div className="w-24 h-1.5 bg-gradient-to-r from-[#8245ec] to-purple-400 mx-auto rounded-full"></div>
        <p className="text-gray-400 text-base sm:text-lg">
          Have an opportunity, project, or question? Reach out and I’ll get back to you promptly.
        </p>
      </div>

      {/* Contact Form Container */}
      <div className="max-w-xl mx-auto bg-white/[0.02] border border-white/10 p-8 sm:p-10 rounded-3xl backdrop-blur-2xl shadow-2xl relative overflow-hidden">
        <div className="absolute top-0 right-0 w-32 h-32 bg-[#8245ec]/10 rounded-full filter blur-2xl pointer-events-none"></div>

        <form ref={form} onSubmit={sendEmail} className="space-y-6 relative z-10">
          
          <div className="space-y-2">
            <label className="text-xs font-semibold text-gray-300 uppercase tracking-wider flex items-center space-x-2">
              <HiUser className="text-[#8245ec]" />
              <span>Your Name</span>
            </label>
            <input
              type="text"
              name="user_name"
              placeholder="e.g. XYZ"
              required
              className="w-full p-4 rounded-xl bg-white/[0.03] text-white border border-white/10 focus:outline-none focus:border-[#8245ec] focus:ring-1 focus:ring-[#8245ec] transition-all text-sm"
            />
          </div>

          <div className="space-y-2">
            <label className="text-xs font-semibold text-gray-300 uppercase tracking-wider flex items-center space-x-2">
              <HiMail className="text-[#8245ec]" />
              <span>Email Address</span>
            </label>
            <input
              type="email"
              name="user_email"
              placeholder="e.g. XYZ@XYZ.com"
              required
              className="w-full p-4 rounded-xl bg-white/[0.03] text-white border border-white/10 focus:outline-none focus:border-[#8245ec] focus:ring-1 focus:ring-[#8245ec] transition-all text-sm"
            />
          </div>

          <div className="space-y-2">
            <label className="text-xs font-semibold text-gray-300 uppercase tracking-wider flex items-center space-x-2">
              <HiChatAlt2 className="text-[#8245ec]" />
              <span>Subject</span>
            </label>
            <input
              type="text"
              name="subject"
              placeholder="Full-Stack Developer Role / Collaboration"
              required
              className="w-full p-4 rounded-xl bg-white/[0.03] text-white border border-white/10 focus:outline-none focus:border-[#8245ec] focus:ring-1 focus:ring-[#8245ec] transition-all text-sm"
            />
          </div>

          <div className="space-y-2">
            <label className="text-xs font-semibold text-gray-300 uppercase tracking-wider flex items-center space-x-2">
              <span>Message</span>
            </label>
            <textarea
              name="message"
              placeholder="Write your message here..."
              rows="4"
              required
              className="w-full p-4 rounded-xl bg-white/[0.03] text-white border border-white/10 focus:outline-none focus:border-[#8245ec] focus:ring-1 focus:ring-[#8245ec] transition-all text-sm resize-none"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full bg-gradient-to-r from-[#8245ec] to-purple-600 py-4 text-white font-bold rounded-xl hover:opacity-90 transition-all duration-300 shadow-[0_0_20px_rgba(130,69,236,0.4)] flex items-center justify-center space-x-2 cursor-pointer"
          >
            <span>{loading ? "Sending..." : "Send Message"}</span>
            <HiPaperAirplane />
          </button>
        </form>
      </div>
    </section>
  );
};

export default Contact;